module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "53px",
      "color": "#999",
      "text-align": "center",
      "padding-top": "40px"
    }
  }, [_vm._v("Freshin")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "27px",
      "color": "#666",
      "text-align": "center"
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "500px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "14px",
      "color": "#333",
      "display": "inline-block",
      "width": "100px"
    }
  }, [_vm._v("请输入手机号")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "display": "inline-block",
      "width": "350px"
    },
    attrs: {
      "size": "large",
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.phonenumber),
      callback: function($$v) {
        _vm.phonenumber = $$v
      },
      expression: "phonenumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('b', {
    staticStyle: {
      "font-size": "14px",
      "color": "#333",
      "display": "inline-block",
      "width": "100px"
    }
  }, [_vm._v("短信验证码")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "display": "inline-block",
      "width": "250px"
    },
    attrs: {
      "size": "large",
      "placeholder": "请输入短信验证码"
    },
    model: {
      value: (_vm.postcode),
      callback: function($$v) {
        _vm.postcode = $$v
      },
      expression: "postcode"
    }
  }), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "display": "inline-block",
      "min-width": "110px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.isdisable
    },
    on: {
      "click": _vm.getcode
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.buttoncontent) + "\n\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.verification
    }
  }, [_vm._v("\n\t\t\t\t\t确认\n\t\t\t\t")])], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "30px",
      "text-align": "center",
      "width": "100%",
      "font-size": "12px"
    }
  }, [_vm._v("powered by Freshin")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94f053fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/forgotpassword/index.vue
// module id = 2395
// module chunks = 1